<template>
  <div>
    <el-dialog
      id="bomDialog"
      title="填写BOM版本号"
      :visible.sync="dialogVisible"
      v-dialogDrag
      :width="isMB?'90%':'450px'"
      :modal="true"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div>
        <el-row>
          <el-col :span="24">
            <span class="title">BOM版本号</span>
            <el-input v-model="data.Bomno" type="text" :style="isMB?'width: 70%;':'width:310px;'" placeholder="请填写BOM版本号"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      data: {
        Bomno: "",
      },
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true;
      this.data.Bomno = "";
    },
    confirm() {
      if(!this.data.Bomno) {
        this.$message.error("请填写BOM版本号");
        return
      }
      this.dialogVisible = false;
      this.$emit("confirm",this.data)
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
#bomDialog {
  .el-col{
    margin: 20px 0px 0 0;
  }
  .title{
    font-size: 14px;
    margin: 0px 10px 0 0;
  }
  /deep/ .el-dialog__body{
    padding-top: 0;
    padding-right: 10px;
  }
}
</style>